import React, { type MouseEvent, useState } from 'react'
import { KibButtonNew, type KibButtonNewProps } from '@chewy/kib-controls-react'
import { Menu } from '@mui/material'
import classNames from 'classnames'

import styles from './KibIconButtonWithMenu.module.scss'

interface KibToggleWithMenuProps extends KibButtonNewProps {
  ariaLabel: string
  ariaLabelSelected: string
  children: React.ReactElement
  openClassName?: string
}

const KibIconButtonWithMenu = ({
  ariaLabel,
  ariaLabelSelected,
  className,
  openClassName = '',
  icon,
  children,
  size,
  theme,
  emphasis,
}: KibToggleWithMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    if (anchorEl) {
      handleClose()
    } else {
      setAnchorEl(event.currentTarget)
    }
  }

  const currentAriaLabel = open ? ariaLabelSelected : ariaLabel
  const menuId = `${currentAriaLabel.replace(' ', '-')}-button-menu`
  const buttonId = `${currentAriaLabel.replace(' ', '-')}-button`

  return (
    <>
      <KibButtonNew
        iconOnly
        aria-controls={open ? menuId : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        aria-label={currentAriaLabel}
        className={classNames(className, {
          [openClassName]: open,
        })}
        emphasis={emphasis}
        icon={icon}
        id={buttonId}
        size={size}
        theme={theme}
        onClick={handleClick}
      />
      <Menu
        MenuListProps={{
          'aria-labelledby': buttonId,
          autoFocus: false,
        }}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        autoFocus={false}
        classes={{ paper: styles.menu, list: styles.menuList }}
        id={menuId}
        open={open}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handleClose}
      >
        {children}
      </Menu>
    </>
  )
}

export default KibIconButtonWithMenu
